export default "__VITE_ASSET__CiA$zXrx__"